import React, { Component } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getLoggedInUser } from './helpers/authUtils';
import Moment, { duration } from 'moment';
import apiAccount from './api/apiAccount';
import apiPush from './api/apiPush';
import apiHome from './api/apiHome';
import { Cookies } from 'react-cookie';
import apiEmail from './api/apiEmail';
import apiConfig from './api/apiConfig';

const MySwal = withReactContent(Swal);

function getUser() {
    return getLoggedInUser();
}

function setUser(account) {
    let user = getUser();
    let token = user.token;
    account.token = token;
    setCookie('user', account);
}

function getImageFullPath(image_url) {
    return apiConfig.configApiUrl + image_url;
}

function alertConfirm(title, message, okbutton, callback) {
    if (title && title != '') {
        Swal.fire({
            title: title,
            html: message,
            // icon: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: '#0a29f5',
            cancelButtonColor: '#a2a2a2',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: okbutton,
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    } else {
        Swal.fire({
            html: message,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: '#0a29f5',
            cancelButtonColor: '#a2a2a2',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: okbutton,
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    }
}

function alertMessage(title, message, okbutton, callback) {
    if (title && title != '') {
        Swal.fire({
            title: title,
            text: message,
            // icon: 'warning',
            confirmButtonColor: '#0a29f5',
            confirmButtonText: okbutton,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    } else {
        Swal.fire({
            text: message,
            confirmButtonColor: '#0a29f5',
            confirmButtonText: okbutton,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    }
}

function alertWarningMessage(title, message, okbutton, callback) {
    if (title && title != '') {
        Swal.fire({
            title: title,
            text: message,
            // icon: 'warning',
            confirmButtonColor: '#f44336',
            confirmButtonText: okbutton,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    } else {
        Swal.fire({
            text: message,
            confirmButtonColor: '#f44336',
            confirmButtonText: okbutton,
        }).then((val) => {
            if (callback) {
                callback(val.isConfirmed);
            }
        });
    }
}

function setCookie(key, value) {
    const cookies = new Cookies();
    cookies.set(key, value);
}

function getCookie(key) {
    const cookies = new Cookies();
    return cookies.get(key);
}

function randomNumber() {
    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
    return rand;
}

function randomIntNumber() {
    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
    return parseInt(rand);
}

function randomInviteCode(numOfLength) {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < numOfLength; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text.toUpperCase();
}

function formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

///============================DATE FUNCTION ==============================//
//+++++++++ START Main date function for control ++++++++++++++//
function getDateTimeNowLocalString() {
    let dtNow = new Date();
    let dtString = Moment(dtNow).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtString;
}

function getDateTimeNowUTCString() {
    let dtNow = new Date();
    let timeZone = dtNow.getTimezoneOffset();
    dtNow.setMinutes(dtNow.getMinutes() + timeZone);
    let dtString = Moment(dtNow).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtString;
}

function getDateTimeUTCFromDateTimeLocal(dateLocal) {
    let timeZone = dateLocal.getTimezoneOffset();
    dateLocal.setMinutes(dateLocal.getMinutes() + timeZone);
    return dateLocal;
}

function getDateTimeLocalFromDateTimeUTC(dateUtc) {
    return new Date(dateUtc);
}

function getDateTimeUTCStringFromLocalDateString(dateLocalString) {
    let dt = new Date(dateLocalString);
    let timeZone = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() + timeZone); //double shift timezone +2*
    let dtUtCString = Moment(dt).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtUtCString;
}

function getDateTimeLocalStringFromUTCDateString(dateUtcString) {
    let dtLocalString = Moment(new Date(dateUtcString)).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtLocalString;
}

function getDateTimeUTCFromDateLocalString(dateLocalString) {
    let utcString = getDateTimeUTCStringFromLocalDateString(dateLocalString);
    let dt = Moment(utcString).toDate();
    let timeZone = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() + timeZone);
    return dt;
}

function getDateTimeLocalFromDateUTCString(dateUtcString) {
    return new Date(dateUtcString);
}

function getDateUTCStringFromDateTimeLocal(dateLocal) {
    let timeZone = dateLocal.getTimezoneOffset();
    dateLocal.setMinutes(dateLocal.getMinutes() + timeZone); //double shift timezone
    let dtUtcString = Moment(dateLocal).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtUtcString;
}

function getDateLocalStringFromDateTimeUTC(dateUtc) {
    let timeZone = dateUtc.getTimezoneOffset();
    dateUtc.setMinutes(dateUtc.getMinutes() - timeZone);
    let dtLocalString = Moment(dateUtc).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtLocalString;
}

function getDateInputLocalStringFromUTCDateString(dateUtcString) {
    let dtLocalString = Moment(dateUtcString).format('YYYY-MM-DD');
    return dtLocalString;
}

function getDateTimeInputLocalStringFromUTCDateString(dateUtcString) {
    let dtLocalString = Moment(dateUtcString).format('YYYY-MM-DDTHH:mm');
    return dtLocalString;
}

function getTimeInputLocalStringFromUTCDateString(dateUtcString) {
    let dtLocalString = Moment(dateUtcString).format('HH:mm');
    return dtLocalString;
}

function getSaveFormatDateStringFromDateString(dateString) {
    return dateString + 'THH:mm:ss.000Z';
}

// function getBirthForSaveFromDateString(dateUtcString) {
//     let btDate = new Date(dateUtcString);
//     let dtString = Moment(btDate).format('YYYY-MM-DD');
//         dtString = dtString + 'T00:00:00' + '.000Z';
//     return dtString;
// }

//+++++++++ END  Main date function for control ++++++++++++++//

// function getDateTimeUTCStringFromDate(dateLocal) {
//     let timeZone = dateLocal.getTimezoneOffset();
//     dateLocal.setMinutes(dateLocal.getMinutes()+timeZone);
//     let dtString = Moment(dateLocal).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
//     return dtString;
// }

// function getDateTimeUTCStringFromDateTimeLocal(dateLocal) {
//     let timeZone = dateLocal.getTimezoneOffset();
//     dateLocal.setMinutes(dateLocal.getMinutes()+timeZone);
//     let dtUtcString = Moment(dateLocal).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
//     return dtUtcString;
// }

// function getDateTimeLocalStringFromDateTimeUTC(dateUtc) {
//     let dtLocalString = Moment(new Date(dateUtc)).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
//     return dtLocalString;
// }

function getDateLocalFormatNow() {
    let dtNow = new Date();
    let dtString = Moment(dtNow).format('YYYY-MM-DD');
    return dtString;
}

function getTimeLocalFormatNow() {
    let dtNow = new Date();
    let dtString = Moment(dtNow).format('HH:mm');
    return dtString;
}

function dateDisplayLocalString(dateUTCString) {
    let dt = new Date(dateUTCString);
    let dtString = Moment(dt).format('MM/DD/YYYY');
    return dtString;
}

const dateTimeDisplayFromDateString = (dateUTCString) => {
    let dt = new Date(dateUTCString);
    let dtString = Moment(dt).format('MM/DD/YYYY HH:mm');
    return dtString;
    // const date = new Date(dateString);
    // const result = date.toLocaleDateString('th-TH', {
    //     year: 'numeric',
    //     month: 'numeric',
    //     day: 'numeric',
    //     hour: 'numeric',
    //     minute: 'numeric',
    // })
    // return result;
};
const dateTimeLongDisplayFromDateString = (dateString) => {
    const date = new Date(dateString);
    const result = date.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
    return result;
};

function getAddBudhaDateString(dateUTCString) {
    let dtNow = dateUTCString ? new Date(dateUTCString) : new Date();
    dtNow.setFullYear(dtNow.getFullYear() + 543);
    let dtString = Moment(dtNow).format('YYYY-MM-DD HH:mm');
    console.log('dtString: ' + dtString);
    return dtString;
}

function getRemoveBudhaDateString(dateString) {
    let dtNow = dateString ? new Date(dateString) : new Date();
    dtNow.setFullYear(dtNow.getFullYear() - 543);
    // let dtString = Moment(dtNow).format('YYYY-MM-DD HH:mm');
    let dtString = Moment(dtNow).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtString;
}

function getDateTimeUTCStringFromSelect(dateLocalString, datetimeLocalString) {
    //remove local time
    // let _dateString = Moment(new Date(dateLocalString)).format('YYYY-MM-DD');
    // let _timeString = Moment(new Date(datetimeLocalString)).format('HH:mm:ss');
    // let dateMix =  Moment(new Date(_dateString+'T'+_timeString));
    // let dateUTC = dateMix.add(-1*dateMix.utcOffset(),'minutes');
    // let dateUTCString = dateUTC.format('YYYY-MM-DDTHH:mm:ss') + '.000Z';

    console.log('mixdate: ' + dateLocalString + 'T' + datetimeLocalString + ':00');

    let dateMix = new Date(dateLocalString + 'T' + datetimeLocalString + ':00');
    console.log('dateUTCString mixdate: ' + dateMix);
    let timeZone = dateMix.getTimezoneOffset();
    dateMix.setMinutes(dateMix.getMinutes() + timeZone);
    let dateUTCString = Moment(dateMix).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';

    console.log('dateUTCString mixdate: ' + dateUTCString);

    return dateUTCString;
}

const monthDisplayFromDateString = (dateString) => {
    const date = new Date(dateString);
    // const result = date.toLocaleDateString('th-TH', {
    //     year: 'numeric',
    //     month: 'long',
    // })
    return getMonthDisplayFromInt(date.getMonth() + 1) + ' ' + date.getFullYear();
};

const dateDisplayFromDateString = (dateString) => {
    const date = new Date(dateString);
    const result = date.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return result;
};

function getDateStringBeginThisYear() {
    let dtNow = new Date();
    let timeZone = dtNow.getTimezoneOffset();
    dtNow.setMinutes(dtNow.getMinutes() + timeZone);
    let dtYearString = dtNow.getFullYear() + '-01-01T00:00:00';
    let dtString = Moment(dtYearString).format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    return dtString;
}

function isBeforeOneMonthFromDateString(dateString) {
    let dtNow = new Date();
    let dtOneMonthString = Moment(dtNow).format('YYYY-MM-01T00:00:00');
    let dtOneMonth = new Date(dtOneMonthString);
    let dtCom = new Date(dateString);
    return Moment(dtCom).isSameOrBefore(dtOneMonth);
}

function isAfterOneMonthFromDateString(dateString) {
    let dtNow = new Date();
    let dtOneMonthString = Moment(dtNow).format('YYYY-MM-01T00:00:00');
    let dtOneMonth = new Date(dtOneMonthString);
    let dtCom = new Date(dateString);
    return Moment(dtCom).isSameOrAfter(dtOneMonth);
}

function getDiffTimeMinutesFromDateString(dateStringLess, dateStringGreater) {
    let dtLess = new Date(dateStringLess);
    let dtGreater = new Date(dateStringGreater);
    return Moment(dtGreater).diff(dtLess, 'minute');
}

function isAfterDate(baseDate, compareDate) {
    return Moment(compareDate).isAfter(baseDate);
}

///============================END DATE FUNCTION ==============================//

const getRandomFilename = (file, index) => {
    let extension = file.name.split('.').pop();
    let dt = Date.now();
    let rd = randomIntNumber();
    let rd2 = randomIntNumber();
    return dt + '_' + rd + '' + rd2 + '_' + (index ?? 0) + '.' + extension;
};

const getBillingStatusDisplay = (status) => {
    switch (status) {
        case 'request':
            return <span className="badge badge-soft-info">รอการชำระเงิน</span>;
        case 'process':
            return <span className="badge badge-soft-warning">รอการตรวจสอบ</span>;
        case 'reject':
            return <span className="badge badge-soft-danger">การชำระไม่ถูกต้อง</span>;
        case 'cancel':
            return <span className="badge badge-soft-danger">ยกเลิก</span>;
        case 'done':
            return <span className="badge badge-soft-success">ชำระเงินแล้ว</span>;

        default:
            return <span className="badge badge-soft-info">รอการชำระเงิน</span>;
    }
};

const getNoticeDisplay = (status) => {
    switch (status) {
        case 'news':
            return 'ข่าวสาร';
        case 'notice':
            return 'ประชาสัมพันธ์';
        case 'alert':
            return 'แจ้งเตือน';
        case 'meeting':
            return 'ประชุม';

        default:
            return 'ข่าวสาร';
    }
};

const getRepairStatusDisplay = (status) => {
    switch (status) {
        case 'request':
            return <span className="badge badge-soft-info">{'รอรับเรื่อง'}</span>;
        case 'accept':
            return <span className="badge badge-soft-info">{'รับเรื่องแล้ว'}</span>;
        case 'waiting_repair':
            return <span className="badge badge-soft-warning">{'รอดำเนินการซ่อม'}</span>;
        case 'waiting_review':
            return <span className="badge badge-soft-info">{'รอการรีวิว'}</span>;
        case 'waiting_result':
            return <span className="badge badge-soft-info">{'รายงานผล'}</span>;
        case 'cancel':
            return <span className="badge badge-soft-danger">{'ยกเลิก'}</span>;
        case 'reject':
            return <span className="badge badge-soft-danger">{'ปฎิเสธการซ่อม'}</span>;
        case 'done':
            return <span className="badge badge-soft-success">{'ดำเนินการเสร็จสิ้น'}</span>;
        case 'waiting_outsource':
            return <span className="badge badge-soft-warning">{'รอช่างภายนอก'}</span>;
        case 'send_repair':
            return <span className="badge badge-soft-warning">{'ส่งซ่อมภายนอก'}</span>;

        default:
            return <span className="badge badge-soft-info">{'รอรับเรื่อง'}</span>;
    }
};

const getHomeRoleDisplay = (role) => {
    switch (role.toLowerCase()) {
        case 'owner':
            return 'เจ้าของกรรมสิทธิ์';
        case 'family':
            return 'ครอบครัว';
        case 'resident':
            return 'ผู้อยู่อาศัย';
        case 'tenant':
            return 'ผู้เช่า';
        case 'other':
            return 'อื่นๆ';
        // case 'approve': return 'ตรวจสอบแล้ว';

        default:
            return '-';
    }
};

const getWorkAreaDisplay = (value) => {
    switch (value.toLowerCase()) {
        case 'private':
            return 'พื้นที่ส่วนตัว';
        case 'public':
            return 'พื้นที่ส่วนกลาง';
        // case 'approve': return 'ตรวจสอบแล้ว';

        default:
            return '-';
    }
};

const getDateFromExcel = (dateExcel) => {
    let date = new Date((dateExcel - (25567 + 2)) * 86400 * 1000);
    let timeZone = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + timeZone);
    let dtString = Moment(date).format('YYYY-MM-DD');
    return dtString;
};

const isValiEmail = (email) => {
    let regEmail =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(email)) {
        return false;
    }

    return true;
};

const isValidWebsite = (url) => {
    if (url) {
        // Step 1: Extract the base URL (ignore path/query)
        // Remove "http://" or "https://" and "www." if present, and ignore path or query
        let baseUrl = url.replace(/^https?:\/\/(www\.)?/, '').split('/')[0];
        console.log('Base URL:', baseUrl); // This should output the domain only

        // Step 2: Regular expression to check if the base domain has a valid structure, allowing "w." as a prefix
        const regexWebsite = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

        // Step 3: Validate the base domain structure
        if (regexWebsite.test(baseUrl)) {
            // Step 4: Check the last segment (TLD) to make sure it has at least 2 characters
            const segments = baseUrl.split('.');
            const lastSegment = segments[segments.length - 1]; // Get the last segment (TLD)

            // If the TLD has at least 2 characters, it's valid
            if (lastSegment.length >= 2) {
                console.log(url + ' is valid');
                return true;
            } else {
                console.log(url + ' is invalid (TLD too short)');
                return false; // TLD must have at least 2 characters
            }
        }

        // Invalid if the URL doesn't match the required pattern or has an invalid TLD
        console.log(url + ' is invalid (invalid domain or TLD)');
        return false;
    }

    return true;
};

const isValidPhone = (phone) => {
    const regex = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
    // return !(regex.test(phone) === false);
    return !(!phone || regex.test(phone) === false);
};

const isValidField = (text) => {
    return !(!text || text == '' || text == ' ');
};

const isValidPassword = (text) => {
    return !(!text || text == '' || text == ' ' || text.indexOf(' ') > -1);
};

const isValidAccountNumber = (accountnumber) => {
    let regex = new RegExp(/^[0-9-]{9,18}$/);
    // return !(regex.test(phone) === false);
    return !(!accountnumber || regex.test(accountnumber) === false);
};

const isValidInput = (text) => {
    return !(!text || text == '' || (text && text.trim(' ').length == 0));
};

const sendInviteCodeByEmail = (email, homeNumber, inviteCode) => {
    let subject = 'Invite code to home number : ' + homeNumber;
    let fromEmail = 'no-reply@aheadall.co.th';
    let toEmailList = [email];
    let htmlBody = `
    Hi,</br>
    You have invite a request.</br>
    Home Number: ${homeNumber}</br>
    Invite Code: <b>${inviteCode}</b>
    </br>
    Thanks
    </br>
    Ahead All team
    `;

    var body = {
        subject: subject,
        fromEmail: fromEmail,
        toEmailList: toEmailList,
        htmlBody: htmlBody,
    };

    apiEmail.createEmail(body);
};

const isValidDateString = (dateString) => {
    var dateFormat = 'YYYY-MM-DD';
    return Moment(Moment(dateString).format(dateFormat), dateFormat, true).isValid();
};

const getBadgeCountForNotiType = (homeMember, notiType) => {
    switch (notiType) {
        case 'payment':
            return homeMember.badgePayment ?? 0;
        case 'package':
            return homeMember.badgePackage ?? 0;
        case 'news':
            return homeMember.badgeNews ?? 0;
        case 'maintenance':
            return homeMember.badgeMaintenance ?? 0;
        case 'feedback':
            return homeMember.badgeFeedback ?? 0;
        case 'chat':
            return homeMember.badgeChat ?? 0;
        case 'techMaintenance':
            return homeMember.badgeMaintenance ?? 0;

        default:
            return 0;
    }
};

const getAllBadgeCountForHomeMember = (homeMember) => {
    return (
        (homeMember.badgePayment ?? 0) +
        (homeMember.badgePackage ?? 0) +
        (homeMember.badgeNews ?? 0) +
        (homeMember.badgeMaintenance ?? 0) +
        (homeMember.badgeFeedback ?? 0) +
        (homeMember.badgeChat ?? 0) +
        (homeMember.badgeTechMaintenance ?? 0)
    );
};

const updateBadgeCountForNotiType = async (homeMember, notiType) => {
    switch (notiType) {
        case 'payment':
            await apiHome.patchHomeMember(homeMember.id, { badgePayment: (homeMember.badgePayment ?? 0) + 1 });
        case 'package':
            await apiHome.patchHomeMember(homeMember.id, { badgePackage: (homeMember.badgePackage ?? 0) + 1 });
        case 'news':
            await apiHome.patchHomeMember(homeMember.id, { badgeNews: (homeMember.badgeNews ?? 0) + 1 });
        case 'maintenance':
            await apiHome.patchHomeMember(homeMember.id, { badgeMaintenance: (homeMember.badgeMaintenance ?? 0) + 1 });
        case 'feedback':
            await apiHome.patchHomeMember(homeMember.id, { badgeFeedback: (homeMember.badgeFeedback ?? 0) + 1 });
        case 'chat':
            await apiHome.patchHomeMember(homeMember.id, { badgeChat: (homeMember.badgeChat ?? 0) + 1 });
        case 'techMaintenance':
            await apiHome.patchHomeMember(homeMember.id, {
                badgeTechMaintenance: (homeMember.badgeTechMaintenance ?? 0) + 1,
            });
    }
};

const getMonthDisplayFromInt = (month) => {
    switch (month) {
        case 1:
            return 'มกราคม';
        case 2:
            return 'กุมภาพันธ์';
        case 3:
            return 'มีนาคม';
        case 4:
            return 'เมษายน';
        case 5:
            return 'พฤษภาคม';
        case 6:
            return 'มิถุนายน';
        case 7:
            return 'กรกฎาคม';
        case 8:
            return 'สิงหาคม';
        case 9:
            return 'กันยายน';
        case 10:
            return 'ตุลาคม';
        case 11:
            return 'พฤศจิกายน';
        case 12:
            return 'ธันวาคม';
    }
};

const pushNotiToAllUserInProperty = async (title, message, image, itemId, notiType) => {
    return new Promise(async function (resolve, reject) {
        var resHomeMembers = await apiHome.getAllHomeMemberActivesForProperty();
        const { status, response } = resHomeMembers ?? {};
        if (status && response) {
            const allProcess = response.map(async (hm, i) => {
                if (
                    hm.user &&
                    hm.user.fcmToken &&
                    hm.user.fcmToken.length > 0 &&
                    hm.user.notify &&
                    hm.home != null &&
                    hm.home.homeNumber != null
                ) {
                    var pushBody = {
                        to: `${hm.user.fcmToken}`,
                        title: `${title} (${hm.home.homeNumber})`,
                        body: `${message}`,
                        image: image,
                        icon: 'noti_icon',
                        badge: getAllBadgeCountForHomeMember(hm, notiType) + 1,
                        data: {
                            url: '',
                            objectId: `${itemId}`,
                            notiType: notiType,
                            homeId: hm.homeId,
                            click_action: 'FLUTTER_NOTIFICATION_CLICK',
                        },
                    };
                    await apiPush.sendPush(pushBody);
                    await updateBadgeCountForNotiType(hm, notiType);

                    //create notificatin data log
                    var body = {
                        title: title,
                        body: message,
                        url: pushBody.data.url,
                        objectId: itemId,
                        notiType: notiType,
                        userId: hm.user.userId,
                        propertyId: hm.user.propertyId ?? '',
                        homeMemberId: hm.id,
                        homeId: hm.homeId,
                        active: true,
                    };
                    await apiPush.createNotification(body);
                }
            });

            Promise.all(allProcess).then(() => {
                resolve('push success');
            });
        } else {
            reject('push error');
        }
    });
};

const pushNotiToHomeMemberByHomeId = async (homeId, title, message, image, itemId, notiType) => {
    return new Promise(async function (resolve, reject) {
        var resHomeMembers = await apiHome.getHomeMembers(homeId);
        const { status, response } = resHomeMembers ?? {};
        if (status && response) {
            const allProcess = response.map(async (hm, i) => {
                if (
                    hm.user &&
                    hm.user.fcmToken &&
                    hm.user.fcmToken.length > 0 &&
                    hm.user.notify &&
                    hm.home != null &&
                    hm.home.homeNumber != null
                ) {
                    var pushBody = {
                        to: `${hm.user.fcmToken}`,
                        title: `${title} (${hm.home.homeNumber})`,
                        body: `${message}`,
                        image: image,
                        icon: 'noti_icon',
                        badge: getAllBadgeCountForHomeMember(hm, notiType) + 1,
                        data: {
                            url: '',
                            objectId: `${itemId}`,
                            notiType: notiType,
                            homeId: homeId,
                            click_action: 'FLUTTER_NOTIFICATION_CLICK',
                        },
                    };
                    await apiPush.sendPush(pushBody);
                    await updateBadgeCountForNotiType(hm, notiType);

                    //create notificatin data log
                    var body = {
                        title: title,
                        body: message,
                        url: pushBody.data.url,
                        objectId: itemId,
                        notiType: notiType,
                        userId: hm.user.userId,
                        propertyId: hm.user.propertyId ?? '',
                        homeMemberId: hm.id,
                        homeId: hm.homeId,
                        active: true,
                    };
                    await apiPush.createNotification(body);
                }
            });

            Promise.all(allProcess).then(() => {
                resolve('push success');
            });
        } else {
            reject('push error');
        }
    });
};

const pushNotiMaintenanceToTechnicianWithHomememberId = async (homeMemberId, title, message, image, maintenacneId) => {
    return new Promise(async function (resolve, reject) {
        let notiType = 'techMaintenance';
        var resHomember = await apiHome.getHomeMemberDetail(homeMemberId);
        const { status, response: hm } = resHomember ?? {};
        if (status && hm) {
            if (hm.user && hm.user.fcmToken && hm.user.fcmToken.length > 0 && hm.user.notify) {
                var pushBody = {
                    to: `${hm.user.fcmToken}`,
                    title: `${title}`,
                    body: `${message}`,
                    image: image,
                    icon: 'noti_icon',
                    badge: getAllBadgeCountForHomeMember(hm, notiType) + 1,
                    data: {
                        url: '',
                        objectId: `${maintenacneId}`,
                        notiType: notiType,
                        click_action: 'FLUTTER_NOTIFICATION_CLICK',
                    },
                };
                var res = await apiPush.sendPush(pushBody);
                console.log('PUSH: ' + JSON.stringify(res));
                await updateBadgeCountForNotiType(hm, notiType);

                //create notificatin data log
                var body = {
                    title: title,
                    body: message,
                    url: pushBody.data.url,
                    objectId: maintenacneId,
                    notiType: notiType,
                    userId: hm.user.userId,
                    propertyId: hm.user.propertyId ?? '',
                    homeMemberId: hm.id,
                    homeId: hm.homeId,
                    active: true,
                };
                await apiPush.createNotification(body);
            }

            resolve('push success');
        } else {
            reject('push error');
        }
    });
};

const pushNotiChatToHomeMemberId = async (homeMemberId, title, message, image, groupChatId, homeId) => {
    return new Promise(async function (resolve, reject) {
        let notiType = 'chat';
        var resHomember = await apiHome.getHomeMemberDetail(homeMemberId);
        const { status, response: hm } = resHomember ?? {};
        if (status && hm) {
            if (
                hm.user &&
                hm.user.fcmToken &&
                hm.user.fcmToken.length > 0 &&
                hm.user.notify &&
                hm.home != null &&
                hm.home.homeNumber != null
            ) {
                var pushBody = {
                    to: `${hm.user.fcmToken}`,
                    title: hm.home ? `${title} (${hm.home.homeNumber})` : `${title}`,
                    body: `${message}`,
                    image: image,
                    icon: 'noti_icon',
                    badge: getAllBadgeCountForHomeMember(hm, notiType) + 1,
                    data: {
                        url: '',
                        objectId: `${groupChatId}`,
                        notiType: 'chat',
                        homeId: homeId ?? '',
                        click_action: 'FLUTTER_NOTIFICATION_CLICK',
                    },
                };
                await apiPush.sendPush(pushBody);
                await updateBadgeCountForNotiType(hm, notiType);
            }

            resolve('push success');
        } else {
            reject('push error');
        }
    });
};

export default {
    getUser,
    setUser,
    getImageFullPath,
    setCookie,
    getCookie,
    randomNumber,
    randomIntNumber,
    randomInviteCode,
    alertConfirm,
    alertMessage,
    alertWarningMessage,
    formatBytes,
    getDateTimeNowLocalString,
    getDateTimeNowUTCString,
    getDateTimeUTCFromDateTimeLocal,
    getDateTimeLocalFromDateTimeUTC,
    getDateTimeUTCStringFromLocalDateString,
    getDateTimeLocalStringFromUTCDateString,
    getDateTimeUTCFromDateLocalString,
    getDateTimeLocalFromDateUTCString,
    getDateUTCStringFromDateTimeLocal,
    getDateLocalStringFromDateTimeUTC,
    getDateInputLocalStringFromUTCDateString,
    getDateTimeInputLocalStringFromUTCDateString,
    getTimeInputLocalStringFromUTCDateString,
    getSaveFormatDateStringFromDateString,
    getDateLocalFormatNow,
    getTimeLocalFormatNow,
    monthDisplayFromDateString,
    dateDisplayFromDateString,
    dateTimeDisplayFromDateString,
    dateDisplayLocalString,
    getAddBudhaDateString,
    getRemoveBudhaDateString,
    dateTimeLongDisplayFromDateString,
    getDateTimeUTCStringFromSelect,
    getDateStringBeginThisYear,
    getRandomFilename,
    isBeforeOneMonthFromDateString,
    isAfterOneMonthFromDateString,
    // getBirthForSaveFromDateString,
    getDiffTimeMinutesFromDateString,
    isAfterDate,
    getBillingStatusDisplay,
    getNoticeDisplay,
    getRepairStatusDisplay,
    getHomeRoleDisplay,
    getWorkAreaDisplay,
    getDateFromExcel,
    isValiEmail,
    isValidWebsite,
    isValidPhone,
    isValidField,
    isValidPassword,
    isValidAccountNumber,
    isValidInput,
    sendInviteCodeByEmail,
    isValidDateString,
    getBadgeCountForNotiType,
    getAllBadgeCountForHomeMember,
    updateBadgeCountForNotiType,
    pushNotiToAllUserInProperty,
    pushNotiToHomeMemberByHomeId,
    pushNotiMaintenanceToTechnicianWithHomememberId,
    pushNotiChatToHomeMemberId,
    getMonthDisplayFromInt,
};
